export const GET_SNIPPETS_PATH = 'api/landlord/snippets';